/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_Continue_VerifiedInputs */

const en_directory_submit_badge_continue_verified = /** @type {(inputs: Directory_Submit_Badge_Continue_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue — badge verified`)
};

const zh_directory_submit_badge_continue_verified = /** @type {(inputs: Directory_Submit_Badge_Continue_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续 — 徽章已验证`)
};

/**
* | output |
* | --- |
* | "Continue — badge verified" |
*
* @param {Directory_Submit_Badge_Continue_VerifiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_continue_verified = /** @type {((inputs?: Directory_Submit_Badge_Continue_VerifiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_Continue_VerifiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_continue_verified(inputs)
	return zh_directory_submit_badge_continue_verified(inputs)
});
export { directory_submit_badge_continue_verified as "directory.submit.badge.continue_verified" }